const aurora = {
  "durations": {
    "snappy": "100ms",
    "quick": "200ms",
    "normal": "300ms",
    "slow": "400ms",
    "slowest": "500ms",
    "demo": "1500ms"
  },
  "easings": {
    "easeInOut": "cubic-bezier(0.645, 0.045, 0.355, 1)",
    "easeIn": "cubic-bezier(0.55, 0.055, 0.675, 0.19)",
    "easeOut": "cubic-bezier(0.215, 0.61, 0.355, 1)",
    "linear": "cubic-bezier(0, 0, 1, 1)"
  },
  "borderRadius": {
    "sm": "0.5rem",
    "md": "0.75rem",
    "lg": "1.25rem",
    "full": "9999rem"
  },
  "breakpoints": {
    "sm": "30em",
    "md": "48em",
    "lg": "62em",
    "xl": "80em"
  },
  "colors": {
    "background": {
      "[base]": "#ffffff",
      "weaker": "#f7f6f5",
      "weak": "#f3f2f1",
      "strong": "#e4e2e0",
      "inverse": {
        "[base]": "#2d2d2d",
        "weaker": "#424242",
        "weak": "#595959",
        "strong": "#767676"
      },
      "primary": {
        "[base]": "#004fcb",
        "weak": "#ecf2ff"
      },
      "action": {
        "[base]": "#ffffff",
        "hover": "#f7f6f5",
        "active": "#f3f2f1",
        "weaker": {
          "[base]": "#f7f6f5",
          "hover": "#f3f2f1",
          "active": "#e4e2e0"
        },
        "weak": {
          "[base]": "#f3f2f1",
          "hover": "#e4e2e0",
          "active": "#d4d2d0"
        },
        "inverse": {
          "[base]": "#2d2d2d",
          "hover": "#424242",
          "active": "#595959"
        },
        "primary": {
          "[base]": "#004fcb",
          "hover": "#003a9b",
          "active": "#002970"
        },
        "destructive": {
          "[base]": "#a9252b",
          "hover": "#83161b",
          "active": "#5f0c10"
        },
        "transparent": {
          "[base]": "rgba(255,255,255,0)",
          "hover": "rgba(255,255,255,0.2)",
          "active": "rgba(255,255,255,0.4)"
        }
      },
      "status": {
        "generic": {
          "[base]": "#595959",
          "weaker": "#f3f2f1"
        },
        "info": {
          "[base]": "#004fcb",
          "weaker": "#ecf2ff"
        },
        "critical": {
          "[base]": "#a9252b",
          "weaker": "#feeeef"
        },
        "success": {
          "[base]": "#1f662c",
          "weaker": "#e4f7e6"
        },
        "warning": {
          "[base]": "#b16300",
          "weaker": "#fdefe9"
        }
      }
    },
    "border": {
      "[base]": "#595959",
      "weak": "#e4e2e0",
      "strong": "#2d2d2d",
      "inverse": {
        "[base]": "#ffffff"
      },
      "primary": {
        "[base]": "#004fcb"
      },
      "action": {
        "[base]": "#595959",
        "hover": "#424242",
        "active": "#2d2d2d",
        "weak": {
          "[base]": "#e4e2e0",
          "hover": "#d4d2d0",
          "active": "#b4b2b1"
        }
      },
      "status": {
        "generic": {
          "[base]": "#d4d2d0"
        },
        "info": {
          "[base]": "#bfd3ff"
        },
        "critical": {
          "[base]": "#f9c5c6",
          "strong": "#a9252b"
        },
        "success": {
          "[base]": "#addfb3"
        },
        "warning": {
          "[base]": "#f7c9b3"
        }
      }
    },
    "indeedLogo": {
      "[base]": "#003a9b",
      "inverse": "#ffffff"
    },
    "skeleton": {
      "gradient": "linear-gradient(270deg, rgba(45, 45, 45, 0) 0%, rgba(45, 45, 45, 0.25) 40%, rgba(45, 45, 45, 0.25) 60%, rgba(45, 45, 45, 0) 100%)"
    },
    "spinner": {
      "[base]": "rgba(45,45,45,0.25)",
      "inverse": "rgba(45,45,45,0.5)"
    },
    "expressive": {
      "gray": {
        "strong": "#595959",
        "weak": "#f3f2f1"
      },
      "earth": {
        "100": "#fef8f4",
        "200": "#fcf0e6",
        "300": "#f9dec5",
        "400": "#f5cb9d",
        "500": "#e0a961",
        "600": "#c08a38",
        "700": "#996e2c",
        "800": "#735324",
        "900": "#553d1c",
        "1000": "#3d2b12",
        "strong": "#735324",
        "weak": "#fcf0e6"
      },
      "orange": {
        "100": "#fef8f7",
        "200": "#fcefeb",
        "300": "#f9ddd3",
        "400": "#f7c8b8",
        "500": "#f39e78",
        "600": "#df7838",
        "700": "#b4602b",
        "800": "#89471e",
        "900": "#623721",
        "1000": "#462615",
        "strong": "#89471e",
        "weak": "#fcefeb"
      },
      "magenta": {
        "100": "#fdf8fa",
        "200": "#fceef4",
        "300": "#f9dae8",
        "400": "#f3c7d9",
        "500": "#ee99bf",
        "600": "#e867a8",
        "700": "#c74289",
        "800": "#9d2b6b",
        "900": "#74234e",
        "1000": "#4f1c36",
        "strong": "#9d2b6b",
        "weak": "#fceef4"
      },
      "purple": {
        "100": "#f9f9fe",
        "200": "#f2f1fe",
        "300": "#e2e0fd",
        "400": "#d2cef6",
        "500": "#b1abf4",
        "600": "#9288ee",
        "700": "#7461e7",
        "800": "#5644bf",
        "900": "#3f2f9b",
        "1000": "#2c2071",
        "strong": "#5644bf",
        "weak": "#f2f1fe"
      },
      "blue": {
        "100": "#f7f9ff",
        "200": "#ecf2ff",
        "300": "#d7e3ff",
        "400": "#bfd3ff",
        "500": "#87b3ff",
        "600": "#5592fd",
        "700": "#336cf6",
        "800": "#004fcb",
        "900": "#003a9b",
        "1000": "#002970",
        "strong": "#004fcb",
        "weak": "#ecf2ff"
      },
      "aqua": {
        "100": "#f5fafe",
        "200": "#e8f3fc",
        "300": "#cde6f9",
        "400": "#b6d7ee",
        "500": "#7abbdf",
        "600": "#409ec8",
        "700": "#237ea3",
        "800": "#1f5f7b",
        "900": "#1d465c",
        "1000": "#123141",
        "strong": "#1f5f7b",
        "weak": "#e8f3fc"
      },
      "green": {
        "100": "#f5fbf9",
        "200": "#e6f5f1",
        "300": "#cde8e1",
        "400": "#b9dad0",
        "500": "#7bc0ae",
        "600": "#4ca38f",
        "700": "#358271",
        "800": "#2b6256",
        "900": "#234840",
        "1000": "#19332d",
        "strong": "#2b6256",
        "weak": "#e6f5f1"
      }
    },
    "foreground": {
      "[base]": "#595959",
      "weak": "#767676",
      "strong": "#2d2d2d",
      "primary": {
        "[base]": "#004fcb"
      },
      "accent": {
        "[base]": "#9d2b6b"
      },
      "inverse": {
        "[base]": "#ffffff"
      },
      "action": {
        "[base]": "#595959",
        "hover": "#424242",
        "active": "#2d2d2d",
        "strong": {
          "[base]": "#2d2d2d",
          "hover": "#424242",
          "active": "#595959"
        },
        "inverse": {
          "[base]": "#ffffff",
          "hover": "#f3f2f1",
          "active": "#e4e2e0"
        },
        "primary": {
          "[base]": "#004fcb",
          "hover": "#003a9b",
          "active": "#002970"
        },
        "destructive": {
          "[base]": "#a9252b",
          "hover": "#83161b",
          "active": "#5f0c10"
        }
      },
      "status": {
        "generic": {
          "[base]": "#595959"
        },
        "info": {
          "[base]": "#004fcb"
        },
        "critical": {
          "[base]": "#a9252b"
        },
        "success": {
          "[base]": "#1f662c"
        },
        "warning": {
          "[base]": "#844b17"
        }
      }
    },
    "primary": {
      "100": "#f7f9ff",
      "200": "#ecf2ff",
      "300": "#d7e3ff",
      "400": "#bfd3ff",
      "500": "#87b3ff",
      "600": "#5592fd",
      "700": "#336cf6",
      "800": "#004fcb",
      "900": "#003a9b",
      "1000": "#002970",
      "1100": "#001d55"
    },
    "neutral": {
      "0": "#ffffff",
      "100": "#f7f6f5",
      "200": "#f3f2f1",
      "300": "#e4e2e0",
      "400": "#d4d2d0",
      "500": "#b4b2b1",
      "600": "#949494",
      "700": "#767676",
      "800": "#595959",
      "900": "#424242",
      "1000": "#2d2d2d",
      "1100": "#222222",
      "1200": "#151515",
      "1300": "#000000"
    },
    "success": {
      "100": "#f3fbf4",
      "200": "#e4f7e6",
      "300": "#c4ecc8",
      "400": "#addfb3",
      "500": "#73c47e",
      "600": "#4da65a",
      "700": "#2a863b",
      "800": "#1f662c",
      "900": "#154c1f",
      "1000": "#0c3614"
    },
    "alert": {
      "100": "#fff8f8",
      "200": "#feeeef",
      "300": "#fcdcdd",
      "400": "#f9c5c6",
      "500": "#fc9597",
      "600": "#f76266",
      "700": "#d93a40",
      "800": "#a9252b",
      "900": "#83161b",
      "1000": "#5f0c10"
    },
    "warning": {
      "100": "#fef8f6",
      "200": "#fdefe9",
      "300": "#fadccf",
      "400": "#f7c9b3",
      "500": "#f39e63",
      "600": "#d87d24",
      "700": "#b16300",
      "800": "#844b17",
      "900": "#623814",
      "1000": "#482708"
    },
    "info": {
      "100": "#f7f9ff",
      "200": "#ecf2ff",
      "300": "#d7e3ff",
      "400": "#bfd3ff",
      "500": "#87b3ff",
      "600": "#5592fd",
      "700": "#336cf6",
      "800": "#004fcb",
      "900": "#003a9b",
      "1000": "#002970"
    },
    "utility": {
      "focus": {
        "[base]": "#004fcb",
        "inverse": "#ffffff"
      },
      "overlay": {
        "[base]": "rgba(45,45,45,0.5)"
      },
      "shadow": {
        "[base]": "#2d2d2d"
      },
      "ai": {
        "weak": {
          "start": "#ecf2ff",
          "end": "#e6f5f1",
          "[base]": "linear-gradient(to top right, #ecf2ff 5%, #e6f5f1 95%)"
        },
        "strong": {
          "start": "#336cf6",
          "end": "#358271",
          "[base]": "linear-gradient(to top right, #336cf6 5%, #358271 95%)"
        }
      }
    }
  },
  "shadows": {
    "inset": "inset 0 0 0.125rem 0 rgba(45,45,45,0.16), inset 0 0.0625rem 0.1875rem 0 rgba(45,45,45,0.08), inset 0 0.125rem 0.25rem 0 rgba(45,45,45,0.04)",
    "low": "0 0 0.125rem 0 rgba(45,45,45,0.16), 0 0.0625rem 0.1875rem 0 rgba(45,45,45,0.08), 0 0.125rem 0.25rem 0 rgba(45,45,45,0.04)",
    "medium": "0 0 0.125rem 0 rgba(45,45,45,0.16), 0 0.25rem 0.5rem 0 rgba(45,45,45,0.08), 0 0.5rem 1rem 0 rgba(45,45,45,0.04)",
    "high": "0 0 0.125rem 0 rgba(45,45,45,0.16), 0 0.5rem 1rem 0 rgba(45,45,45,0.08), 0 1rem 1.5rem 0 rgba(45,45,45,0.04)",
    "mobilePopover": "0 0 0.125rem 0 rgba(45,45,45,0.04), 0 -0.5rem 1rem 0 rgba(45,45,45,0.04), 0 -1rem 1.5rem 0 rgba(45,45,45,0.04)",
    "focus": {
      "[base]": "0 0 0 0.125rem rgb(255,255,255), 0 0 0 0.25rem rgb(0,79,203)",
      "inset": "inset 0 0 0 0.125rem rgb(0,79,203)"
    }
  },
  "spacing": {
    "1": "0.25rem",
    "2": "0.5rem",
    "3": "0.75rem",
    "4": "1rem",
    "5": "1.5rem",
    "6": "2rem",
    "7": "3rem",
    "8": "4rem",
    "9": "5rem",
    "10": "6rem",
    "11": "8rem",
    "12": "10rem",
    "13": "12rem",
    "sc2": "0.375rem",
    "sc3": "0.625rem",
    "sc4": "0.875rem",
    "scb1": "0.1875rem",
    "scb2": "0.3125rem",
    "scb3": "0.5625rem",
    "scb4": "0.8125rem"
  },
  "fonts": {
    "default": "'Indeed Sans', 'Noto Sans', 'Helvetica Neue', Helvetica, Arial, 'Liberation Sans', Roboto, Noto, sans-serif"
  },
  "fontSizes": {
    "1": "0.75rem",
    "2": "0.875rem",
    "3": "1rem",
    "4": "1.25rem",
    "5": "1.5rem",
    "6": "1.75rem",
    "7": "2.25rem",
    "8": "2.75rem"
  },
  "fontWeights": {
    "normal": 400,
    "medium": 500,
    "bold": 700
  },
  "lineHeights": {
    "tighter": 1.125,
    "tight": 1.25,
    "normal": 1.5,
    "loose": 1.75
  }
};
const {
  durations,
  easings,
  borderRadius,
  breakpoints,
  colors,
  shadows,
  spacing,
  fonts,
  fontSizes,
  fontWeights,
  lineHeights
} = aurora;

export { aurora, borderRadius, breakpoints, colors, aurora as default, durations, easings, fontSizes, fontWeights, fonts, lineHeights, shadows, spacing };
